import React from 'react';
export function Story() {
  return <section id="story" className="py-24 px-6 border-t border-gray-100 scroll-mt-20" data-id="element-139">
      <div className="max-w-2xl mx-auto text-center space-y-8" data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-light" data-id="element-141">
          Made to be your only candle.
        </h2>

        <div className="space-y-6 text-gray-600 leading-relaxed font-light" data-id="element-142">
          <p data-id="element-143">
            This candle was created with one idea: focus on one product and make
            it exceptional. No big catalogue, no unnecessary options — just a
            single, intentional object crafted with care.
          </p>
          <p data-id="element-144">
            Our signature scent, Smoked Pine, is inspired by quiet winter
            evenings and soft natural wood notes. The gloss black vessel brings
            a refined, modern feel that blends into any home without effort.
          </p>
          <p data-id="element-145">
            Each candle is hand-poured in England using clean, responsibly
            sourced ingredients. Designed to burn slowly, cleanly, and
            beautifully — this is the only candle you'll ever need.
          </p>
        </div>
      </div>
    </section>;
}